import { defineStore } from "pinia";

interface ErrorState {
  error: string;
}

export const useErrorStore = defineStore("error", {
  state: (): ErrorState => ({
    error: "",
  }),

  actions: {
    throwError(error: string) {
      this.error = error;
    },

    clearError() {
      this.error = "";
    },
  },
});
